import React, { Component, LabelHTMLAttributes } from 'react';

class FormicaLabel extends Component<Props> {
  render() {
    const { label, className, ...rest } = this.props;
    return (
      <label className={`text-sm text-primary ${className}`} {...rest}>
        {label}
      </label>
    );
  }
}

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {
  label: string;
}

export default FormicaLabel;
